module.exports = __webpack_public_path__ + "img/trash.ee5d104d.svg";